import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import { formatFileSize, formatSecondsLeft } from "../utils";
import type { UploadProgress } from "../types";

type UploadedFileRowProps = {
  fileName: string;
  fileSize: number;
  isUploading: boolean;
  progress: UploadProgress;
  onRemove: () => void;
};

const UploadedFileRow = ({ fileName, fileSize, isUploading, progress, onRemove }: UploadedFileRowProps) => {
  const timeLeftLabel = formatSecondsLeft(progress.secondsLeft);

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-rounded-[10px] tw-border tw-border-uploader-border tw-bg-uploader-row-bg tw-px-4 tw-py-2.5">
      <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-3">
        <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1789725855/intel/misc/upload_bulk_woppkm.svg`} alt="" className="tw-h-[30px] tw-w-[30px] tw-shrink-0" />
        <div className="tw-min-w-0">
          <div className="tw-truncate tw-text-base tw-font-medium tw-text-uploader-title">{fileName}</div>
          <div className="tw-mt-0.5 tw-flex tw-items-center tw-gap-3 tw-text-sm tw-text-uploader-meta">
            <span>{formatFileSize(fileSize)}</span>
            {isUploading ? (
              <>
                <span>{Math.round(progress.percent)}%</span>
                {timeLeftLabel && <span>{timeLeftLabel}</span>}
                <span className="tw-h-4 tw-w-4 tw-animate-spin tw-rounded-full tw-border-2 tw-border-gray-200 tw-border-t-primary-purple-600" />
                <span>Uploading</span>
              </>
            ) : (
              <>
                <span className="material-symbols-outlined tw-text-base tw-leading-none tw-text-success-600">check_circle</span>
                <span>Uploaded successfully</span>
              </>
            )}
          </div>
        </div>
      </div>
      <button type="button" onClick={onRemove} aria-label="Remove file" className="tw-flex tw-h-11 tw-w-11 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-[10px] tw-border tw-border-uploader-trash tw-bg-white hover:tw-bg-gray-50">
        <span className="material-symbols-outlined tw-text-xl tw-leading-none tw-text-gray-600">delete</span>
      </button>
    </div>
  );
};

export default UploadedFileRow;
